import { render, staticRenderFns } from "./SelectVariationStatus.vue?vue&type=template&id=47d9df36"
import script from "./SelectVariationStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectVariationStatus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d9df36')) {
      api.createRecord('47d9df36', component.options)
    } else {
      api.reload('47d9df36', component.options)
    }
    module.hot.accept("./SelectVariationStatus.vue?vue&type=template&id=47d9df36", function () {
      api.rerender('47d9df36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/teacher/indicator/components/SelectVariationStatus.vue"
export default component.exports